<template>
  <div class="sign-in">
    <md-card md-with-hover v-cloak>
      <md-card-media>
        <img class="image" src="/static/maxima-logo.svg"/>
      </md-card-media>

      <md-card-header>
        <div class="md-title">Maxima-Online</div>
        <translate tag="div" class="md-subhead">Set new password</translate>
      </md-card-header>

      <transition name="new-pwd">
        <md-card-content v-if="step === 1">
          <form novalidate @submit.stop.prevent="submit">
            <md-input-container :class="{'md-input-invalid': !validPassword(passNew) && passNewDirty }">
              <translate tag="label">New password</translate>
              <md-input id="password" @input.native="inputNewPassword()" type="password" v-model="passNew"></md-input>
            </md-input-container>
            <md-input-container :class="{'md-input-invalid': passNew !== passConf && passConfDirty }">
              <translate tag="label">Confirm new password</translate>
              <md-input id="password-conf" @input.native="inputConfPassword()" type="password" v-model="passConf"></md-input>
              <span class="md-error"><translate>Password and confirmation do not match</translate></span>
            </md-input-container>
          </form>
        </md-card-content>
      </transition>
      <transition name="new-pwd">
        <md-card-content v-if="step === 2" class="text-info" key="step-2">
          <translate>The password has been successfully reset.</translate>
        </md-card-content>
      </transition>
      <transition name="new-pwd">
        <md-card-content v-if="step === 3" class="text-info" key="step-3">
          <translate>An error occured. The requested link is either wrong or expired. Please try to reset your password again.</translate>
        </md-card-content>
      </transition>

      <md-card-actions v-if="step === 1">
        <md-button id="confirm-button" @click.native="confirmNew" class="md-primary md-raised"><translate>Confirm new password</translate></md-button>
      </md-card-actions>
      <md-card-actions v-else>
        <router-link tag="button" to="/sign-in" class="md-primary md-button"><translate>Return</translate></router-link>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import auth from '../../auth'

export default {
  name: 'reset-new',
  data () {
    return {
      token: '',
      passNew: '',
      passNewDirty: false,
      passConf: '',
      passConfDirty: false,
      step: 0
    }
  },
  async created () {
    // check if the token exists in DB
    this.token = this.$route.params.token
    if (await auth.checkResetToken(this.token)) {
      this.step = 1
    } else {
      this.step = 3
    }
  },
  methods: {
    async confirmNew () {
      this.passConfDirty = true
      this.passNewDirty = true
      if (this.passNew === this.passConf && this.validPassword(this.passNew)) {
        if (await auth.setNewPassword(this.token, this.passNew)) {
          this.step = 2
        } else {
          this.step = 3
        }
      }
    },
    validPassword (password) {
      return password.length > 0 // TODO min size of password ?
    },
    inputNewPassword () {
      this.passNewDirty = true
    },
    inputConfPassword () {
      // this.passConfDirty = true // no need to annoy user with error until he press the confirm button
    }
  }
}
</script>

<style scoped>
[v-cloak] {
  display: none!important;
}
.sign-in {
  width: 25rem;
  margin: 10em auto;
}
.image {
  width: 100% !important;
  padding: 30px 30px 10px 30px;
}
.text-info {
  margin-top: 20px;
}

.new-pwd-enter-active {
  transition: all .5s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/login/ResetNew.vue